import { Controller } from "@hotwired/stimulus"

const COLOR_HEX = {
  low:      "#9ca3af",
  medium:   "#3b82f6",
  high:     "#f97316",
  critical: "#ef4444"
}

export default class extends Controller {
  static targets = ["nativeSelect", "selectedDisplay", "selectedDot", "selectedLabel",
                    "search", "dropdown", "list"]

  connect() {
    this.allOptions = Array.from(this.nativeSelectTarget.options).map(opt => ({
      value: opt.value,
      label: opt.text
    }))

    const selected = this.allOptions.find(o => o.value === this.nativeSelectTarget.value)
    if (selected) this._setDisplay(selected)

    this._renderList(this.allOptions)
    this._outsideClick = this._onOutsideClick.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    this._isOpen() ? this.close() : this.open()
  }

  open() {
    this.selectedDisplayTarget.classList.add("hidden")
    this.searchTarget.classList.remove("hidden")
    this.dropdownTarget.classList.remove("hidden")
    this.searchTarget.value = ""
    this._renderList(this.allOptions)
    this.searchTarget.focus()
    document.addEventListener("click", this._outsideClick)
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    this.searchTarget.classList.add("hidden")
    this.selectedDisplayTarget.classList.remove("hidden")
    this.searchTarget.value = ""
    document.removeEventListener("click", this._outsideClick)
  }

  filter() {
    const q = this.searchTarget.value.toLowerCase()
    const filtered = q ? this.allOptions.filter(o => o.label.toLowerCase().includes(q)) : this.allOptions
    this._renderList(filtered)
  }

  select(event) {
    const li = event.currentTarget
    const opt = { value: li.dataset.value, label: li.dataset.label }
    this.nativeSelectTarget.value = opt.value
    this._setDisplay(opt)
    this.close()
  }

  stopProp(event) {
    event.stopPropagation()
  }

  _isOpen() {
    return !this.dropdownTarget.classList.contains("hidden")
  }

  _setDisplay(opt) {
    this.selectedDotTarget.style.background = COLOR_HEX[opt.value] || "#9ca3af"
    this.selectedLabelTarget.textContent = opt.label
    this.selectedLabelTarget.classList.remove("text-gray-400", "dark:text-gray-500")
    this.selectedLabelTarget.classList.add("text-gray-900", "dark:text-gray-100")
  }

  _renderList(options) {
    this.listTarget.replaceChildren()
    options.forEach(opt => {
      const li = document.createElement("li")
      li.dataset.value = opt.value
      li.dataset.label = opt.label
      li.dataset.action = "click->priority-select#select"
      li.className = "flex items-center gap-2 px-3 py-2 text-sm text-gray-800 dark:text-gray-200 hover:bg-indigo-50 dark:hover:bg-indigo-950/40 cursor-pointer"

      const dot = document.createElement("span")
      dot.className = "w-2.5 h-2.5 rounded-full shrink-0"
      dot.style.background = COLOR_HEX[opt.value] || "#9ca3af"

      const label = document.createElement("span")
      label.textContent = opt.label

      li.append(dot, label)
      this.listTarget.appendChild(li)
    })

    if (options.length === 0) {
      const empty = document.createElement("li")
      empty.className = "px-3 py-2 text-sm text-gray-400 dark:text-gray-500"
      empty.textContent = "No results"
      this.listTarget.appendChild(empty)
    }
  }

  _onOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
